var map = {
	"./bialystok/podatek-lesny/section-2_pl.mdx": [
		60160,
		60160
	],
	"./bydgoszcz/podatek-lesny/section-2_pl.mdx": [
		15143,
		15143
	],
	"./czestochowa/podatek-lesny/section-2_pl.mdx": [
		13514,
		13514
	],
	"./garwolin/podatek-lesny/section-2_pl.mdx": [
		91105,
		91105
	],
	"./gdansk/podatek-lesny/section-2_pl.mdx": [
		53776,
		53776
	],
	"./gdynia/podatek-lesny/section-2_pl.mdx": [
		52240,
		52240
	],
	"./gliwice/podatek-lesny/section-2_pl.mdx": [
		13656,
		13656
	],
	"./gmina-swidnica/podatek-lesny/section-2_pl.mdx": [
		9421,
		9421
	],
	"./kielce/podatek-lesny/section-2_pl.mdx": [
		40363,
		40363
	],
	"./kolobrzeg/podatek-lesny/section-2_pl.mdx": [
		92393,
		92393
	],
	"./konskowola/podatek-lesny/section-2_pl.mdx": [
		61728,
		61728
	],
	"./koszalin/podatek-lesny/section-2_pl.mdx": [
		63491,
		63491
	],
	"./lask/podatek-lesny/section-2_pl.mdx": [
		93599,
		93599
	],
	"./lodz/podatek-lesny/section-2_pl.mdx": [
		53245,
		53245
	],
	"./lublin/podatek-lesny/section-2_pl.mdx": [
		39712,
		39712
	],
	"./miejsce-piastowe/podatek-lesny/section-2_pl.mdx": [
		9449,
		9449
	],
	"./mikolow/podatek-lesny/section-2_pl.mdx": [
		54352,
		54352
	],
	"./naklo/podatek-lesny/section-2_pl.mdx": [
		39041,
		39041
	],
	"./oborniki/podatek-lesny/section-2_pl.mdx": [
		6563,
		6563
	],
	"./olesnica/podatek-lesny/section-2_pl.mdx": [
		34136,
		34136
	],
	"./postomino/podatek-lesny/section-2_pl.mdx": [
		41812,
		41812
	],
	"./poznan/podatek-lesny/section-2_pl.mdx": [
		64652,
		64652
	],
	"./przechlewo/podatek-lesny/section-2_pl.mdx": [
		16368,
		93987
	],
	"./radom/podatek-lesny/section-2_pl.mdx": [
		48289,
		48289
	],
	"./raszkow/podatek-lesny/section-2_pl.mdx": [
		52346,
		29965
	],
	"./rawicz/podatek-lesny/section-2_pl.mdx": [
		95806,
		95806
	],
	"./ryman/podatek-lesny/section-2_pl.mdx": [
		32277,
		32277
	],
	"./sierakowice/podatek-lesny/section-2_pl.mdx": [
		21194,
		21194
	],
	"./slawno/podatek-lesny/section-2_pl.mdx": [
		55410,
		55410
	],
	"./slawoborze/podatek-lesny/section-2_pl.mdx": [
		71244,
		71244
	],
	"./stare-babice/podatek-lesny/section-2_pl.mdx": [
		75708,
		75708
	],
	"./szczecin/podatek-lesny/section-2_pl.mdx": [
		93933,
		93933
	],
	"./szemud/podatek-lesny/section-2_pl.mdx": [
		13892,
		13892
	],
	"./warszawa/podatek-lesny/section-2_pl.mdx": [
		67696,
		67696
	],
	"./wloszczowa/podatek-lesny/section-2_pl.mdx": [
		14343,
		14343
	],
	"./wroclaw/podatek-lesny/section-2_pl.mdx": [
		50983,
		50983
	],
	"./wyszkow/podatek-lesny/section-2_pl.mdx": [
		93238,
		93238
	],
	"./zukowo/podatek-lesny/section-2_pl.mdx": [
		53683,
		53683
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6447;
module.exports = webpackAsyncContext;